import { useAction, useAtom } from '@reatom/npm-react'
import { useEffect, useMemo } from 'react'

import { AsyncStateN } from '@blade/std-lib'
import { reatomCancelLimitOrder } from '@root/features/trade/limit-orders'
import { useTranslation } from '@root/shared/localization'
import { ConfirmDrawer } from '@root/shared/ui-kit'

import type { LimitOrderId } from '@root/entities/limit-order/model/limit-order-id'
import type { DrawerControlProps } from '@root/shared/ui-kit'

type CloseOrderDrawerProps = {
  orderId: LimitOrderId
} & DrawerControlProps

export const CloseOrderDrawer: React.FC<CloseOrderDrawerProps> = ({
  orderId,
  open,
  onOpenChange,
}) => {
  const { t } = useTranslation()

  const { cancelOrderAction, cancelStateAtom } = useMemo(
    () => reatomCancelLimitOrder({ orderId: orderId }),
    [orderId],
  )

  const [state] = useAtom(cancelStateAtom)
  const closeOrder = useAction(cancelOrderAction)

  useEffect(() => {
    if (AsyncStateN.isSuccess(state)) {
      onOpenChange?.(false)
    }
  }, [onOpenChange, state])

  return (
    <ConfirmDrawer
      intent="error"
      title={t('order.close-order-confirm-title')}
      description={t('order.close-order-confirm-description')}
      onConfirm={() => {
        closeOrder()
      }}
      busy={state.loading}
      open={open}
      onOpenChange={onOpenChange}
    ></ConfirmDrawer>
  )
}
